// extracted by css-extract-rspack-plugin
export default {"cls1":"ImpactStatTile-cls1_L0S","cls2":"ImpactStatTile-cls2_7mB ImpactStatTile-cls1_L0S"};